import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.math.hypot.js";

var Vector = /*#__PURE__*/function () {
  function Vector(x, y) {
    _classCallCheck(this, Vector);

    this.x = x;
    this.y = y;
  }

  _createClass(Vector, [{
    key: "add",
    value: function add(v) {
      return new Vector(this.x + v.x, this.y + v.y);
    }
  }, {
    key: "addTo",
    value: function addTo(v) {
      this.x += v.x;
      this.y += v.y;
    }
  }, {
    key: "sub",
    value: function sub(v) {
      return new Vector(this.x - v.x, this.y - v.y);
    }
  }, {
    key: "subFrom",
    value: function subFrom(v) {
      this.x -= v.x;
      this.y -= v.y;
    }
  }, {
    key: "mult",
    value: function mult(n) {
      return new Vector(this.x * n, this.y * n);
    }
  }, {
    key: "div",
    value: function div(n) {
      return new Vector(this.x / n, this.y / n);
    }
  }, {
    key: "setAngle",
    value: function setAngle(angle) {
      var length = this.getLength();
      this.x = Math.cos(angle) * length;
      this.y = Math.sin(angle) * length;
      return this;
    }
  }, {
    key: "setLength",
    value: function setLength(length) {
      var angle = this.getAngle();
      this.x = Math.cos(angle) * length;
      this.y = Math.sin(angle) * length;
      return this;
    }
  }, {
    key: "getAngle",
    value: function getAngle() {
      return Math.atan2(this.y, this.x);
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return Math.hypot(this.x, this.y);
    }
  }, {
    key: "getLengthSq",
    value: function getLengthSq() {
      return this.x * this.x + this.y * this.y;
    }
  }, {
    key: "distanceTo",
    value: function distanceTo(v) {
      return this.sub(v).getLength();
    }
  }, {
    key: "distanceToSq",
    value: function distanceToSq(v) {
      return this.sub(v).getLengthSq();
    }
  }, {
    key: "copy",
    value: function copy() {
      return new Vector(this.x, this.y);
    }
  }, {
    key: "rotate",
    value: function rotate(angle) {
      return new Vector(this.x * Math.cos(angle) - this.y * Math.sin(angle), this.x * Math.sin(angle) + this.y * Math.cos(angle));
    }
  }, {
    key: "rotateAround",
    value: function rotateAround(v, angle) {
      var x = (this.x - v.x) * Math.cos(angle) - (v.y - this.y) * Math.sin(angle) + v.x;
      var y = (v.y - this.y) * Math.cos(angle) + (this.x - v.x) * Math.sin(angle) + v.y;
      return new Vector(x, y);
    }
  }, {
    key: "lerp",
    value: function lerp(v, t) {
      var delta = v.sub(this).mult(t);
      return this.add(delta);
    }
  }, {
    key: "lerpTo",
    value: function lerpTo(v, t) {
      var delta = v.sub(this).mult(t);
      this.addTo(delta);
    }
  }, {
    key: "moveTowards",
    value: function moveTowards(v, length) {
      var delta = v.sub(this).setLength(length);
      return this.add(delta);
    }
  }, {
    key: "equals",
    value: function equals(v) {
      return this.x == v.x && this.y == v.y;
    }
  }]);

  return Vector;
}();

export { Vector as default };